import {
  generateDateIdKey,
  getOverlappingMilestonesByDateAndResource,
  getResourcesWithOverlappingMilestones,
} from '@/core/milestones/milestoneOperationsUtils';
import { useMilestoneStore } from '@/core/milestones/milestoneStore';
import { EVENT_LAYOUT_STACK } from '@/features/schedule/bryntum/resources/const';
import { useScheduleViewStore } from '@/features/scheduleViews/scheduleViewStore';
import { isMilestoneVisible } from '@/services/store/schedule/actions/filter';
import { getMainResourceId } from '@/services/store/schedule/parsers/base';
import { SchedulerResource } from '@/services/store/schedule/types/entities';

export const useOverlappingMilestones = () => {
  const milestoneStore = useMilestoneStore();
  const { currentFilter } = useScheduleViewStore();

  const visibleMilestones = computed(() =>
    milestoneStore.milestoneList.filter((m) => isMilestoneVisible(m, currentFilter)),
  );

  const overlappingMilestonesByDateAndResource = computed(() =>
    getOverlappingMilestonesByDateAndResource(visibleMilestones.value),
  );

  const resourcesWithOverlappingMilestones = computed(() =>
    getResourcesWithOverlappingMilestones(overlappingMilestonesByDateAndResource.value),
  );

  const getNumberOfOverlappingMilestonesForDate = (date: Date, resource: SchedulerResource) => {
    const numOfOverlappingMilestones =
      overlappingMilestonesByDateAndResource.value[generateDateIdKey(date, resource.id)] ?? 0;

    const result =
      resource.id !== getMainResourceId() && resource.eventLayout !== EVENT_LAYOUT_STACK
        ? numOfOverlappingMilestones
        : 0;
    return result;
  };

  const checkDateHasOverlappingMilestones = (date: Date, resource: SchedulerResource) => {
    return getNumberOfOverlappingMilestonesForDate(date, resource) > 1;
  };

  return {
    overlappingMilestonesByDateAndResource,
    resourcesWithOverlappingMilestones,
    getNumberOfOverlappingMilestonesForDate,
    checkDateHasOverlappingMilestones,
  };
};
